<template>
  <v-app>
    <v-content>
      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          max-width="600">
          <v-card>
            <v-card-title class="headline">{{head_info}}</v-card-title>
            <v-card-text>
              {{info}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="dialog = false, info = '', redirectLogin(resultRegistration)">
                {{$t('ok')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-card
        class="mx-auto"
        max-width="700"
        style="padding:30px; margin:30px; z-index:1;">
        <v-card-text>
          <div>{{$t('registration')}}</div>
         <div class="switch d-flex align-start">
            <h1 class="switch__current-lang">RU</h1>
            <v-switch :color="$mainColor" v-model="changeLanguage" label="EN"></v-switch>
          </div>
          <v-row>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="lastName"
                :label="surNameLabel"
                placeholder="Фамилия"
                :error-messages="lastNameValidate"
                :error="lastName_error"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="name"
                 placeholder="Имя"
                :label="nameLabel"
                required
                :error-messages="nameValidate"
                :error="name_error"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="middleName"
                 placeholder="Отчество"
                :label="patronymicLabel"
                required
                :error-messages="middleNameValidate"
                :error="middleName_error"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="valueOrganization"
                :items="organizations"
                item-value="id"
                item-text="name"
                :label='scienceOrganizationLabel'
                prepend-icon="mdi-city"
                :error="valueOrganization_error"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="academic_degree"
                :items="rang"
                item-text="title"
                item-value="id"
                :label='scienceDegreeLabel'
                prepend-icon="mdi-account"
                :error="academic_degree_error"
                >
              </v-autocomplete>
            </v-col>
            <!--v-col cols="12" lg="6">
              <v-autocomplete
                v-model="academic_rank"
                :items="states"
                item-text="title"
                item-value="id"
                :label='scienceRankLabel'
                prepend-icon="mdi-account"
                :error="academic_rank_error">
              </v-autocomplete>
            </v-col-->
          </v-row>
          <v-row>
            <v-col cols="12" lg="12">
              <v-menu
                v-model="birthDay"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedDate"
                    :label="birthDayLabel"
                    :hint="hint"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_date" 
                  no-title
                  scrollable
                  @input="birthDay = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="1950-01-01"
                ></v-date-picker>
              </v-menu>
            </v-col>

          </v-row>
        </v-card-text>
        <v-card-text>
          <div>{{$t('login-details')}}</div>
          <form autocomplete="off">
           
            <v-text-field
              v-model="email"
              label="E-mail"
              placeholder="synchrotron@nrcki.ru"
              autocomplete="new-password"
              required
              :error-messages="emailValidate"
              :error="email_error"
            ></v-text-field>
            
            <v-card-subtitle
            style="padding: 0;">{{phoneLabel}}</v-card-subtitle>
            <v-text-field
              style="margin-top:0; padding-top:5px;"
              class="phone-number"
              v-model="phone"
               placeholder="918 333 33 33"
              required
              :error-messages="phoneValidate"
              :error="phone_error"
            ></v-text-field>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="password"
                  :append-icon="eyePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="eyePassword ? 'text' : 'password'"
                  name="input-10-1"
                  placeholder="qQ123ds!!"
                  autocomplete="off"
                  :label="passwordLabel"
                  :error-messages="passwordValidate"
                  :error="password_error"
                  @click:append="eyePassword = !eyePassword"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  :append-icon="eyePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="eyePassword ? 'text' : 'password'"
                  @click:append="eyePassword = !eyePassword"
                  name="input-10-2"
                  :label="repeatPasswordLabel"
                  placeholder="qQ123456!!"
                  v-model="confirmPassword"
                  class="input-group--focused"
                  :error-messages="password !== confirmPassword ? $t('registrationPage.passwords_must_match') : null"
                  :error="confirmPassword_error"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-checkbox
              :color="$mainColor"
              v-model="checkbox"
              :label="confirmRulesLabel"
              required
              
              :error-messages="checkboxCheck(checkbox)"
              :error="checkbox_error"
            ></v-checkbox>
            <v-btn
              :color="buttonColor"
              :loading="loaded"
              dark
              outlined
              class="mr-4"
              style="margin-top:10px;"
              @click="submit">{{buttonTextSubmit}}
            </v-btn>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            small
            target='_blank'
            @click="policy_dialog = true"
            color="#16336e">
            Политика конфиденциальности
          </v-btn>
          <!-- <v-btn
            text
            small
            href='https://atknin.com/media/brhr_personal_data.pdf'
            target='_blank'
            color="#16336e">
            {{this.$t('read-user-agreement')}}
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-content>

    <v-dialog v-model="policy_dialog" max-width="80%">
      <v-card  class="mx-auto content-personal" style="padding:30px; margin:30px; margin-top: 0px;" >
        <user-policy></user-policy>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="policy_dialog = false">закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <animate-bg />
    <!--widget-render-file
        :name="'registration'" /--> 
  </v-app>
</template>

<script>
import intlTelInput from 'intl-tel-input';
import { validationMixin } from 'vuelidate';
import { required, maxLength, email, minLength } from 'vuelidate/lib/validators/';
import { mapActions, mapGetters,mapMutations } from 'vuex';
import userAgrement from '../user_agrement.json'
import animateBg from '../components/animate-bg/animateBg'
import WidgetRenderFile from '../components/widgets/render-file'
import UserPolicy from '../components/Common/UserPolicy.vue';

export default {
  name: 'Registration',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  components: {
    animateBg,
    WidgetRenderFile,
    UserPolicy,
  },
  data: () => ({
    loaded: false,
    resultRegistration: false,
    eyePassword: false,
    checkbox_error: false,
    name_error: false,
    lastName_error: false,
    middleName_error: false,
    phone_error: false,
    email_error: false,
    password_error: false,
    confirmPassword_error: false,
    valueOrganization_error: false,
    academic_degree_error: false,
    academic_rank_error: false,
    userAgrement,
    policy_dialog: false,
    dialog: false,
    name: '',
    lastName: '',
    middleName: '',
    phone: '',
    email: '',
    info: '',
    changeLanguage: '',
    select: null,
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPassword: false,
    checkbox: true,
    academic_degree: '',
    academic_rank: '',
    valueOrganization: '',
    organizations: [],
    rang: [],
    states: [],
    new_date: '2000-01-01',
    birthDay: false,
    head_info: '',
    buttonColor: '#16336e',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
    disabled: true,
    codeCountry: ''
  }),
  mounted() {

    this.changeLanguage = localStorage.language==='ru' ? false : true;
    
   /* document.querySelector('#input-72').setAttribute('autocomplete', 'off')
    document.querySelector('#input-78').setAttribute('autocomplete', 'off')
    document.querySelector('#input-82').setAttribute('autocomplete', 'off')*/

    let phoneInput = document.querySelector('.phone-number input');
    this.codeCountry = intlTelInput(phoneInput, {
      separateDialCode: true,
      preferredCountries: ['ru', 'ua', 'kz', 'by']
    })
  },
  async beforeMount() {
   
      const rang = await this.GET_ACADEMIC_DEGREE_REG(this.GETTERS_APP_LANGUAGE_NTRANSLATE);
      const states = await this.GET_ACADEMIC_RANK_REG(this.GETTERS_APP_LANGUAGE_NTRANSLATE);
      const organizations = await this.ORGANIZATION(this.GETTERS_APP_LANGUAGE_NTRANSLATE);

      this.organizations = await organizations.data;
      this.rang = await rang.data;
      this.states = await states.data;
    
  },
  validations: {
    lastName: {
      required,
      minLength: minLength(1)
    },
    name: {
      required,
      minLength: minLength(1)
    },
    middleName: {
      required,
      minLength: minLength(2)
    },
    phone: {
      required,
      validFormat: val => /\d{1,}/.test(val)
    },
    password: {
      required,
      validFormat: val => /[a-z]{1,}/.test(val) && val.length >= 8
    },
    academic_degree: {
      required,
      minLength: minLength(1)
    },
    email: {
      required,
      email
    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_APP_LANGUAGE_NTRANSLATE',
      'GETTERS_APP_LANGUAGE'
    ]),
    lastNameValidate() {
      return this.$v.lastName.$invalid && this.$v.lastName.required ?
      this.$t('Registration.three_or_more_characters') : null
    },
    nameValidate() {
      return this.$v.name.$invalid && this.$v.name.required ?
      this.$t('Registration.three_or_more_characters') : null
    },
    middleNameValidate() {
      return this.$v.middleName.$invalid && this.$v.middleName.required ?
      this.$t('Registration.three_or_more_characters') : null
    },
    emailValidate() {
      return this.$v.email.$invalid && this.$v.email.required ?
      this.$t('Registration.enter_valid_email') : null
    },
    phoneValidate() {
      return this.$v.phone.$invalid && this.$v.phone.required ?
      this.$t('Registration.correct_phone_number') : null
    },
    passwordValidate() {
      return this.$v.password.$invalid && this.$v.password.required ?
      this.$t('Registration.eight_or_more_characters') : null
    },
    academic_degree_validate() {
      return this.$v.academic_degree.$invalid && this.$v.academic_degree.required ?
      this.$t('Registration.select_value') : null
    },
    surNameLabel(){
      return this.$t('sur-name-label')
    },
    scienceOrganizationLabel(){
      return this.$t('organization-label')
    },
    confirmRulesLabel(){
      return this.$t('confirmRules')
    },
    nameLabel(){
      return this.$t('name-label')
    },
    patronymicLabel(){
     return this.$t('patronymic-label')
    },
    repeatPasswordLabel(){
      return this.$t('repeat-password')
    },
    passwordLabel(){
      return this.$t('password')
    },
    rulesPassword(){
      return this.$t('rules-password')
    },
    hint(){
      return this.$t('hint-bd')
    },
    birthDayLabel(){
      return this.$t('bd-label')
    },
    phoneLabel(){
      return this.$t('phone-label')
    },
    scienceRankLabel(){
      return this.$t('rank-label')
    },
    scienceDegreeLabel(){
      return this.$t('degree-label')
    },
    buttonTextSubmit(){
      return this.$t('create-account')
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    computedDate() {
      return this.formatDate(this.new_date);
    },

    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      if (!this.$v.select.required) errors.push('Item is required');
      return errors;
    },
    count() {
      return this.$store.state.count;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.maxLength) errors.push('очень длинное имя');
      if (!this.$v.name.required) errors.push('укажите Ваше имя');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push('неверный e-mail');
      if (!this.$v.email.required) errors.push('введите e-mail');
      return errors;
    },
  },
  methods: {
    ...mapActions([
      'REGISTRATION',
      'GET_ACADEMIC_DEGREE_REG',
      'GET_ACADEMIC_RANK_REG',
      'ORGANIZATION'
    ]),
    ...mapMutations(['SET_APP_LANGUAGE']),
    checkboxCheck(check) {
      if (check === null) return null;
      if (!check) return this.$t('registrationPage.required_field');
      if (check) return null
    },
    redirectLogin(redirect) {
      redirect ? this.$router.push('/login') : null
    },
    get_params() {
      return {
        username: this.email,
        email: this.email,
        password: this.password,
        password_confirm: this.confirmPassword,
        first_name: this.name,
        last_name: this.lastName,
        individual: {
          middle_name: this.middleName,
          phone_number: this.codeCountry.getSelectedCountryData().dialCode + this.phone,
          academic_degree: this.academic_degree,
          //academic_rank: this.academic_rank,
          organization: this.valueOrganization,
          birth_date: this.new_date+'T15:00',
        },
      };
    },
    async submit() {
      
      this.loaded = true;
      const userData = this.get_params();

      //this.academic_rank.length === 0 ? this.academic_rank_error = true : this.academic_rank_error = false
      this.academic_degree.length === 0 ? this.academic_degree_error = true : this.academic_degree_error = false
      this.valueOrganization.length === 0 ? this.valueOrganization_error = true : this.valueOrganization_error = false

      this.name.length === 0 ? this.name_error = true : this.name_error = false
      this.lastName.length === 0 ? this.lastName_error = true : this.lastName_error = false
      this.middleName.length === 0 ? this.middleName_error = true : this.middleName_error = false
      this.phone.length === 0 ? this.phone_error = true : this.phone_error = false
      this.email.length === 0 ? this.email_error = true : this.email_error = false
      this.password.length === 0 ? this.password_error = true : this.password_error = false
      this.confirmPassword.length === 0 ? this.confirmPassword_error = true : this.confirmPassword_error = false
      !this.checkbox && this.checkbox === null ? this.checkbox_error = true : this.checkbox_error = false
      
  
      if (//(this.academic_rank.length === 0) ||
        (this.academic_degree.length === 0) ||
        (this.valueOrganization.length === 0) ||
        !this.checkbox ||
        this.$v.$invalid) {
          this.buttonColor = '#DC5959'
          this.loaded = false
          return
        };
      
      this.buttonColor = '#656565';
      this.REGISTRATION(userData)
      .then((res) => {
        if(res.data.errors !== undefined)
          this.show_reg_errors(res.data.errors)
        else{
          this.buttonText = this.$t('create_account');
          this.buttonColor = this.$mainColor;
        
          this.head_info = this.$t('Registration.you_registered');
          this.info = this.$t('Registration.confirm_email')
          this.dialog = true;

          this.resultRegistration = true
          this.loaded = false
        }

      })
      .catch( (error) => {
        this.info += `Что-то пошло не так... Обновите страницу и попробуйте зарегистрироваться еще раз. Если ошибка повторится, напишите нам: admin@kcsni-service.ru.`;
        this.loaded = false
        this.dialog = true;
        this.resultRegistration = false
        this.head_info = this.$t('error');
        this.buttonText = this.$t('create_account');
        this.buttonColor = this.$mainColor;

        // if (error.response.data.hasOwnProperty('username')) {
          //this.$messageHelper(`${error.response.data.username[0]}`, 'error', 3000)
          // this.info += `${error.response.data.username[0]}`;
        // }
        //  if (error.response.data.hasOwnProperty('password')) {
          //this.$messageHelper(`${error.response.data.password[0]}`, 'error', 3000)
          // this.info += `, ${error.response.data.password[0]}`;
        // }
        
      })

    },
    
    show_reg_errors(errors){
      Object.entries(errors).forEach(([key, val]) => {
        val.forEach(t => {
          this.info += t;
          this.info += ' ';
        })  
      });

      this.loaded = false
      this.dialog = true;
      this.resultRegistration = false
      this.head_info = this.$t('error');
      this.buttonText = this.$t('create_account');
      this.buttonColor = this.$mainColor;
    },

    clear() {
      this.$v.$reset();
      this.name = '';
      this.email = '';
      this.select = null;
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },

  watch: {
    changeLanguage(newLang) {
      if (newLang) {
        this.SET_APP_LANGUAGE('en');
        this.$i18n.locale = 'en';
      }
      else {
        this.SET_APP_LANGUAGE('ru');
        this.$i18n.locale = 'ru';
      }
    },
    email(val){
      this.email = val.toLowerCase()
    },

    async GETTERS_APP_LANGUAGE_NTRANSLATE(val) {
      try {
        const rang = await this.GET_ACADEMIC_DEGREE(val);
        const states = await this.GET_ACADEMIC_RANK(val);
        const organizations = await this.ORGANIZATION(val);
        
        this.organizations = organizations.data;
        this.rang = rang.data;
        this.states = states.data;
    } catch (ex) {
      console.log('ex ---> ', ex);
      // this.$toasted.show('Произошла ошибка!', { type: 'error', duration: 3000 });
    }
    }
  }
};
</script>
<style lang="scss">
.invalid {
  color: red;
  border: 1px solid red !important;
}
</style>